import React, { useEffect, useState } from "react";
import { Lock } from "lucide-react";

// Rank display: prefer an explicit rank on the account; otherwise derive from role.
const ROLE_RANK = {
  field_unit: "Officer",
  pa_state_constable: "Constable",
  supervisor: "Lieutenant",
  watch_commander: "Major",
  records_supervisor: "Lieutenant",
  admin: "Major",
  police_dispatcher: "Dispatcher",
  fire_dispatcher: "Dispatcher",
  ems_dispatcher: "Dispatcher",
  call_taker: "Telecommunicator",
};

// Privacy lock screen for the MDT — clean, government-style. Click anywhere to resume.
export default function MDTLockScreen({ user, unit, onResume }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const iv = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(iv); }, []);

  const parts = (user?.name || "Officer").trim().split(/\s+/);
  const initialLast = parts.length > 1 ? `${parts[0][0]}. ${parts[parts.length - 1]}` : parts[0];
  const rank = user?.rank || ROLE_RANK[user?.role] || "Officer";
  const agency = user?.agency || "Matcom Office Of Public Safety";
  const time = now.toLocaleTimeString("en-GB", { hour12: false });
  const date = now.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" });

  return (
    <div data-testid="mdt-lock-screen" onClick={onResume}
      className="fixed inset-0 z-[2000] flex flex-col items-center justify-center cursor-pointer select-none px-6"
      style={{ background: "radial-gradient(circle at 50% 30%, #0f1524 0%, #07090f 70%)" }}>

      {/* Agency seal */}
      <div className="w-24 h-24 rounded-full flex items-center justify-center overflow-hidden"
        style={{ background: "#0b1424", border: "1px solid #2b4a7a", boxShadow: "0 0 40px #1e3a6a44" }}>
        <img src="/agency-logo.jpg" alt={agency} className="w-full h-full object-contain p-2" />
      </div>

      {/* Agency */}
      <div data-testid="mdt-lock-agency" className="font-head font-bold text-xl sm:text-2xl text-white tracking-wide uppercase mt-5 text-center">
        {agency}
      </div>

      <div className="w-48 h-px my-8" style={{ background: "linear-gradient(90deg, transparent, #8a6d2f, transparent)" }} />

      {/* Time */}
      <div className="font-mono font-bold text-6xl sm:text-7xl text-white tracking-[0.12em] tabular-nums" data-testid="mdt-lock-clock">{time}</div>
      <div className="font-mono text-sm text-[#E0B23C] mt-2 tracking-wide">{date}</div>

      <div className="w-48 h-px my-8" style={{ background: "linear-gradient(90deg, transparent, #2C2D35, transparent)" }} />

      {/* Rank + F. Lastname · Unit */}
      <div data-testid="mdt-lock-officer" className="font-head text-lg text-white tracking-wide">
        {rank} {initialLast}
      </div>
      <div data-testid="mdt-lock-unit" className="font-mono text-sm text-[#9CA3AF] mt-1.5 tracking-[0.25em] uppercase">
        Unit {unit || user?.badge || "—"}
      </div>

      <div className="font-mono text-[11px] text-[#5B6472] mt-12 flex items-center gap-2 uppercase tracking-widest">
        <Lock size={12} /> Locked — Click Anywhere To Resume
      </div>
      <div className="font-mono text-[10px] text-[#3f4c8a] mt-10 tracking-[0.3em] uppercase text-center">
        For Official Use Only — Unauthorized Access Is Prohibited
      </div>
    </div>
  );
}
